export type TooltipRow = {
	name: string;
	tagName: string;
	color: string;
	value: number | null;
	exact?: boolean;
};

const buildLabel = ({ name, tagName }: TooltipRow) =>
	tagName && tagName !== name ? `${name} [${tagName}]` : name;

const formatTooltipValue = (value: unknown) => {
	if (value === null || value === undefined || value === "") {
		return "-";
	}

	const numericValue = Number(value);
	if (!Number.isFinite(numericValue)) {
		return String(value);
	}

	if (Number.isInteger(numericValue)) {
		return numericValue.toString();
	}

	return numericValue.toLocaleString(undefined, {
		maximumFractionDigits: 5,
	});
};

const pad = (value: number, size = 2) => value.toString().padStart(size, "0");

const formatTooltipTime = (time: number, withMilliseconds: boolean) => {
	const date = new Date(time);
	if (Number.isNaN(date.getTime())) return "";

	const day = `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
	const clock = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
	const base = `${day} ${clock}`;

	return withMilliseconds ? `${base}.${pad(date.getMilliseconds(), 3)}` : base;
};

const buildMarker = (color: string) =>
	`<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${color};margin-right:5px;"></span>`;

export const buildTooltipHtml = (
	hoveredTime: number,
	rows: TooltipRow[],
): string => {
	if (rows.length === 0) return "";

	const snapped = rows.some((row) => row.exact);

	const header = `<div style="font-weight: bold; margin-bottom: 5px;">${formatTooltipTime(
		hoveredTime,
		snapped,
	)}</div>`;

	return rows.reduce((html, row) => {
		const style = row.exact ? ' style="font-weight:bold;"' : "";

		return `${html}<div${style}>${buildMarker(row.color)}${buildLabel(row)}: ${formatTooltipValue(
			row.value,
		)}</div>`;
	}, header);
};
